import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.mask = IMask(this.inputTarget, {
      mask: [
        {
          mask: '+7 (000) 000-00-00',
          startsWith: '+7'
        },
        {
          mask: '+1 (000) 000-0000',
          startsWith: '+1'
        },
        {
          mask: '+44 0000 000000',
          startsWith: '+44'
        },
        {
          mask: '+49 000 00000000',
          startsWith: '+49'
        },
        {
          mask: '+33 0 00 00 00 00',
          startsWith: '+33'
        },
        {
          mask: '+39 000 000 0000',
          startsWith: '+39'
        },
        {
          mask: '+34 000 000 000',
          startsWith: '+34'
        },
        {
          mask: '+380 00 000 00 00',
          startsWith: '+380'
        },
        {
          mask: '+375 00 000-00-00',
          startsWith: '+375'
        },
        {
          mask: '+374 00 000000',
          startsWith: '+374'
        },
        {
          mask: '+994 00 000 00 00',
          startsWith: '+994'
        },
        {
          mask: '+995 000 000 000',
          startsWith: '+995'
        },
        {
          mask: '+998 00 000 00 00',
          startsWith: '+998'
        },
        {
          mask: '+996 000 000 000',
          startsWith: '+996'
        },
        {
          mask: '+992 00 000 0000',
          startsWith: '+992'
        },
        {
          mask: '+993 0 000-0000',
          startsWith: '+993'
        },
        {
          mask: '+00000000000000000',
          startsWith: '+'
        }
      ],
      dispatch: function (appended, dynamicMasked) {
        const number = (dynamicMasked.value + appended).replace(/\D/g, '');

        return dynamicMasked.compiledMasks.find(function (m) {
          return number.indexOf(m.startsWith.replace(/\D/g, '')) === 0;
        });
      }
    })

    // Set default value to +7 if input is empty
    if (!this.inputTarget.value) {
      this.mask.value = '+7'
    }
  }

  disconnect() {
    if (this.mask) {
      this.mask.destroy()
    }
  }
}
